import { Fragment, useEffect, useState } from "react";
import {
  Avatar,
  AvatarGroup,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Iconify from "../Iconify";
import useResponsive from "../../hooks/useResponsive";

export interface IProps {
  file: any;
  alt?: string;
  baseUrl?: string;
  width?: number;
  height?: number;
  style?: any;
  hasShow?: boolean;
  pointer?: boolean;
}

export default ({
  file,
  alt = " ",
  baseUrl = "",
  // width = 48,
  // height = 48,
  width,
  height,
  style = {},
  hasShow = false,
  pointer = false,
}: IProps) => {
  const theme = useTheme();
  const isDesktop = useResponsive("up", "lg");
  const fWidth = width ?? (isDesktop ? 40 : 30);
  const fHeight = height ?? (isDesktop ? 40 : 30);
  const [open, setOpen] = useState(false);
  const [showIndex, setShowIndex] = useState(0);

  const onOpen = () => {
    if (hasShow) {
      setShowIndex(0);
      setOpen(true);
    }
  };
  const onClose = () => {
    setShowIndex(0);
    setOpen(false);
  };

  if (file && file.length > 0) {
    return (
      <Fragment>
        {Array.isArray(file) && file.length > 1 ? (
          <AvatarGroup
            spacing={isDesktop ? 40 : 30}
            onClick={onOpen}
            sx={hasShow || pointer ? { cursor: "pointer" } : {}}
          >
            {/* {file.map((f: any, i: number) => (
            <Avatar
              key={`avatar-group-${alt}-${i}`}
              src={`${baseUrl}${f}`}
              alt={alt}
              sx={{ width, height, flexShrink: 0, ...style }}
            />
          ))} */}
            <Avatar
              key={`avatar-group-${alt}-0`}
              src={`${baseUrl}${file[0]}`}
              alt={alt}
              sx={{ width: fWidth, height: fHeight, flexShrink: 0, ...style }}
            />
            <Avatar
              key={`avatar-group-${alt}-1`}
              src={`${baseUrl}${file[1]}`}
              alt={alt}
              sx={{ width: fWidth, height: fHeight, flexShrink: 0, ...style }}
            />
          </AvatarGroup>
        ) : (
          <Avatar
            src={`${baseUrl}${Array.isArray(file) ? file[0] : file}`}
            alt={alt}
            sx={{
              width: fWidth,
              height: fHeight,
              flexShrink: 0,
              cursor: hasShow || pointer ? "pointer" : "default",
              ...style,
            }}
            onClick={onOpen}
          />
        )}

        {open && (
          <Dialog open={true} onClose={onClose} fullWidth maxWidth="lg">
            <DialogContent>
              <IconButton
                edge="start"
                color="inherit"
                onClick={onClose}
                aria-label="close"
                sx={{
                  // float: "right",
                  fontWeight: "bold",
                  // marginTop: "-15px",
                  marginLeft: 0,
                  position: "absolute",
                  right: 0,
                  top: 0,
                }}
                size="small"
              >
                <Iconify
                  icon={"ep:close-bold"}
                  width={20}
                  sx={{ color: "error.dark" }}
                />
              </IconButton>

              {Array.isArray(file) && file.length > 1 && (
                <Grid sx={{ mb: 1, textAlign: "center" }}>
                  {file.map((f: any, i: number) => (
                    <span
                      key={`avatar-dialog-${alt}-${i}`}
                      style={{
                        display: "inline-block",
                        padding: "5px",
                        cursor: "pointer",
                      }}
                    >
                      <Avatar
                        alt={alt}
                        src={`${baseUrl}${f}`}
                        sx={{
                          width: 60,
                          height: 60,
                          margin: "auto",
                          boxShadow:
                            showIndex === i
                              ? `0 0 25px ${theme.palette.primary.main}`
                              : "none",
                        }}
                        onClick={() => setShowIndex(i)}
                      />
                    </span>
                  ))}
                </Grid>
              )}
              <Grid sx={{ width: "100%", textAlign: "center" }}>
                <Avatar
                  src={`${baseUrl}${
                    Array.isArray(file) ? file[showIndex] : file
                  }`}
                  alt={alt}
                  sx={{
                    // width:
                    //   window.innerWidth > window.innerHeight ? "50vw" : "auto",
                    // height:
                    //   window.innerWidth > window.innerHeight ? "auto" : "50vh",
                    height:
                      window.innerWidth > window.innerHeight
                        ? window.innerHeight - 250
                        : "auto",
                    width:
                      window.innerWidth > window.innerHeight
                        ? "auto"
                        : window.innerWidth - 128,
                    flexShrink: 0,
                    display: "inline-block",
                  }}
                />
              </Grid>
            </DialogContent>
          </Dialog>
        )}
      </Fragment>
    );
  } else {
    return (
      <Avatar
        sx={{
          width: fWidth,
          height: fHeight,
          flexShrink: 0,
          backgroundColor: "primary.lighter",
          color: "primary.dark",
          ...style,
        }}
      >{`${alt.charAt(0)}`}</Avatar>
    );
  }
};
